import { render } from "./MemoryChart.vue?vue&type=template&id=4fe0becf&scoped=true"
import script from "./MemoryChart.vue?vue&type=script&lang=js"
export * from "./MemoryChart.vue?vue&type=script&lang=js"

import "./MemoryChart.vue?vue&type=style&index=0&id=4fe0becf&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe0becf"]])

export default __exports__